import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import DocumentDetailSummary from './DocumentDetailSummary';
import DirectionsCar from '@mui/icons-material/DirectionsCar';
import InsuranceCard from './InsuranceCard';
import { useGlobalSubscription } from 'providers/GlobalCacheManager';
import { ASSET_IMAGE_DOWNLOADED } from '../subscriptions';
import { CollapseCard } from '@totalsoft/rocket-ui';

const DocumentDetailCard = ({ expanded, documentDetail, onExpand }) => {
  const handleExpand = useCallback((_, expanded) => onExpand(!expanded, documentDetail), [documentDetail, onExpand]);

  const simulations = useMemo(() => documentDetail?.insuranceSimulations || [], [documentDetail]);

  useGlobalSubscription(ASSET_IMAGE_DOWNLOADED, {
    skip: !documentDetail.assetHierarchy?.id,
    variables: { assetHierarchyId: documentDetail.assetHierarchy?.id }
  });

  return (
    <CollapseCard
      id={`${documentDetail?.documentDetailId}-${documentDetail?.siteId}`}
      icon={DirectionsCar}
      expanded={expanded}
      canExpand={documentDetail.insuranceSimulations.length > 0}
      onToggle={handleExpand}
      title={expanded ? documentDetail?.item.typeName : <></>}
      subheader={<DocumentDetailSummary documentDetail={documentDetail} />}
      hideSubheaderOnExpand
      toggleOnHeaderClick
    >
      {expanded ? (
        <>
          {simulations &&
            simulations.length > 0 &&
            [...simulations].reverse().map(simulation => {
              return <InsuranceCard key={simulation.id} documentDetail={documentDetail} simulation={simulation} />;
            })}
        </>
      ) : (
        <></>
      )}
    </CollapseCard>
  );
};

DocumentDetailCard.propTypes = {
  documentDetail: PropTypes.object.isRequired,
  expanded: PropTypes.bool.isRequired,
  onExpand: PropTypes.func.isRequired
};

export default DocumentDetailCard;
